export default __webpack_public_path__ + "static/media/barnesBtn.780a030b.png";